export const CONTACT_US_CODE_DEFAULT = '1001';
export const CONTACT_US_CODE_JOINT_OWNER_EXISTS = '1002';
